import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { ResolveAuth } from '@/features/auth/ResolveAuth';

const AppFrame = lazy(() => import('./AppFrame'));
const DeviceSettings = lazy(() => import('./DeviceSettings'));
const Guide = lazy(() => import('./Guide'));
const Home = lazy(() => import('./Home'));
const Login = lazy(() => import('./Login'));
const MeetingSetup = lazy(() => import('@/features/meeting/MeetingSetup'));
const Meeting = lazy(() => import('./Room'));
const RootRoute = lazy(() => import('./RootRoute'));
const UserDetail = lazy(() => import('./UserDetail'));

export const router = createBrowserRouter([
  {
    element: <ResolveAuth required={false} />,
    children: [
      {
        path: '/',
        element: <RootRoute />,
        children: [
          {
            index: true,
            element: <Home />,
          },
        ],
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/guide',
        element: <Guide />,
      },
    ],
  },
  {
    element: <ResolveAuth required={true} />,
    children: [
      {
        element: <AppFrame />,
        children: [
          {
            path: '/users/:userId',
            element: <UserDetail />,
          },
          {
            path: '/rooms/:roomId',
            element: <MeetingSetup />,
            children: [
              {
                path: 'settings',
                element: <DeviceSettings />,
              },
              {
                index: true,
                element: <Meeting />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
